module.exports = __webpack_public_path__ + "img/user.6239f8ea.svg";